import React, { useContext, useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { AuthContext } from "../../../context/Authcontext";

import toast from "react-hot-toast";
import api from "../../../utils/api";

const base_url = process.env.REACT_APP_API_URL;

const AdminMatches = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const { getRoles } = useContext(AuthContext);
  const [matches, setMatches] = useState([]);
  const [filteredMatches, setFilteredMatches] = useState([]); // For search filtering
  const [loading, setLoading] = useState(false);
  const [addAllLoading, setAddAllLoading] = useState(false); // Loading for Add All button
  const [addMatchLoading, setAddMatchLoading] = useState({}); // Loading for individual Add buttons
  const [activeTab, setActiveTab] = useState("myMatches");
  const [activeTab1, setActiveTab1] = useState("Cricket");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [searchTerm, setSearchTerm] = useState(""); // Search state
  const [lockStates, setLockStates] = useState({}); // Track lock states for each match

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Search functionality
  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
    if (!searchValue.trim()) {
      setFilteredMatches(matches);
      return;
    }

    const filtered = matches.filter((match) =>
      match.eventname?.toLowerCase().includes(searchValue.toLowerCase()) ||
      match.competitionname?.toLowerCase().includes(searchValue.toLowerCase()) ||
      match.marketname?.toLowerCase().includes(searchValue.toLowerCase()) ||
      match.sportname?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredMatches(filtered);
  };

  // Update filtered matches when matches data changes
  useEffect(() => {
    handleSearch(searchTerm);
  }, [matches, searchTerm]);

  const toggleLockMatch = async (newStatus, eventid) => {
    try {
      // Optimistically update the UI
      setLockStates(prev => ({
        ...prev,
        [eventid]: newStatus
      }));

      const response = await api.post(
        "/api/admin/lockMatch",
        { status: newStatus, eventid },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data.success) {
        toast.success("Match Locked/UnLocked successfully");
        // Update the matches state to reflect the change
        setMatches(prevMatches => 
          prevMatches.map(match => 
            match.eventid === eventid 
              ? { ...match, lockstatus: newStatus }
              : match
          )
        );
      } else {
        // Revert the optimistic update if API call failed
        setLockStates(prev => ({
          ...prev,
          [eventid]: newStatus === 2 ? 1 : 2
        }));
        // console.warn("Match Locked/UnLocked failed");
        toast.error("Failed to update match status");
      }
    } catch (error) {
      // Revert the optimistic update if API call failed
      setLockStates(prev => ({
        ...prev,
        [eventid]: newStatus === 2 ? 1 : 2
      }));
      console.error("Error locking match", error);
      toast.error("Error updating match status");
    }
  };

  const GetAllMatches = async (Type) => {
    setLoading(true);
    // Clear previous lock states when fetching new data
    setLockStates({});

    try {
      const auth = localStorage.getItem("admin");

      const response = await api.get(
        `/api/webapi/admin/getAllMatch`,
        {
          params: { Type },
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      const data = response?.data.data;
      setMatches(data || []);
      
      // Initialize lock states for new matches
      if (data && data.length > 0) {
        const initialLockStates = {};
        data.forEach(match => {
          initialLockStates[match.eventid] = match.lockstatus;
        });
        setLockStates(initialLockStates);
      }
      
    } catch (error) {
      console.error("Error fetching matches:", error);
      toast.error("Error fetching matches");
    } finally {
      setLoading(false);
    }
  };

  const GetMyMatches = async (Type) => {
    setLoading(true);
    // Clear previous lock states when fetching new data
    setLockStates({});

    try {
      const auth = localStorage.getItem("admin");

      const response = await api.get(
        `/api/webapi/admin/getMyMatch`,
        {
          params: { Type },
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      const data = response?.data.data;
      setMatches(data || []);
      
      // Initialize lock states for new matches
      if (data && data.length > 0) {
        const initialLockStates = {};
        data.forEach(match => {
          initialLockStates[match.eventid] = match.lockstatus;
        });
        setLockStates(initialLockStates);
      }
      
      // console.log("My Matches received:", data);
    } catch (error) {
      console.error("Error fetching matches:", error);
      toast.error("Error fetching matches");
    } finally {
      setLoading(false);
    }
  };

  const AddMatch = async (MatchId) => {
    // Set loading state for specific match
    setAddMatchLoading(prev => ({
      ...prev,
      [MatchId]: true
    }));

    try {
      const auth = localStorage.getItem("admin");

      const response = await api.post(
        `/api/webapi/admin/addMatch?MatchId=${MatchId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      if (response.data.success) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error adding match:", error);
      toast.error("Error Adding Match");
    } finally {
      // Clear loading state for specific match
      setAddMatchLoading(prev => ({
        ...prev,
        [MatchId]: false
      }));
    }
  };

  const handleAll = async () => {
    setAddAllLoading(true); // Set loading for Add All button

    try {
      const auth = localStorage.getItem('admin');
      const alleventIds = matches.map((match) => match.eventid);
      const selectionid = matches.map((match) => match.selectionid);

      const response = await api.post('/api/webapi/admin/addAllMatch',
        { alleventIds, selectionid },
        {
          headers: {
            'content-type': 'application/json',
            Authorization: `${auth}`,
          }
        }
      );

      if (response?.data.success) {
        toast.success(response?.data.message);
      } else {
        toast.error(response?.data.message);
      }
    } catch (err) {
      console.log(err);
      toast.error("Error adding all matches");
    } finally {
      setAddAllLoading(false); // Clear loading for Add All button
    }
  };

  const handleRefresh = () => {
    if (activeTab === "myMatches") {
      GetMyMatches(activeTab1);
    } else {
      GetAllMatches(activeTab1);
    }
    setSearchTerm("");
  };

  useEffect(() => {
    GetMyMatches("Cricket");
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <div className="wrapper">
        {/* <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}
        
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
          <div className="container-fluid pt-3">
            <h5 className="m-0">Add Matches</h5>
          </div>
          
          <section className="content">
            {/* Main Tab Navigation */}
            <div className="mt-2 tophead d-flex justify-content-between">
              <div className="d-flex align-items-center cursor-pointer">
                <div
                  className={`p-2 mid ${activeTab === "myMatches" ? "bg-dark text-white" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setActiveTab("myMatches");
                    setActiveTab1("Cricket");
                    GetMyMatches("Cricket");
                  }}
                >
                  My Matches
                </div>

                <div
                  className={`p-2 mid ${activeTab === "upcomingMatches" ? "bg-dark text-white" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setActiveTab("upcomingMatches");
                    setActiveTab1("Cricket");
                    GetAllMatches("Cricket");
                  }}
                >
                  Upcoming Matches
                </div>
              </div>
            </div>

            {/* Sport Navigation and Controls */}
            <div className="mt-2 tophead d-flex justify-content-between">
              <div className="d-flex align-items-center cursor-pointer">
                <div 
                  className={`p-2 mid ${activeTab1 === "Cricket" ? "bg-dark text-white" : ""}`} 
                  style={{ cursor: "pointer" }} 
                  onClick={() => {
                    setActiveTab1("Cricket");
                    if (activeTab === "myMatches") {
                      GetMyMatches("Cricket");
                    } else {
                      GetAllMatches("Cricket");
                    }
                  }}
                >
                  <img src="/assets/images/crickball1.png" height="20px" width="20px" alt="Cricket Ball" />
                  Cricket
                </div>

                <div 
                  className={`p-2 mid ${activeTab1 === "Tennis" ? "bg-dark text-white" : ""}`} 
                  style={{ cursor: "pointer" }} 
                  onClick={() => {
                    setActiveTab1("Tennis");
                    if (activeTab === "myMatches") {
                      GetMyMatches("Tennis");
                    } else {
                      GetAllMatches("Tennis");
                    }
                  }}
                >
                  <img src="/assets/images/tennis1.png" height="20px" width="20px" alt="Tennis Ball" />
                  Tennis
                </div>

                <div 
                  className={`p-2 mid ${activeTab1 === "Soccer" ? "bg-dark text-white" : ""}`} 
                  style={{ cursor: "pointer" }} 
                  onClick={() => {
                    setActiveTab1("Soccer");
                    if (activeTab === "myMatches") {
                      GetMyMatches("Soccer");
                    } else {
                      GetAllMatches("Soccer");
                    }
                  }}
                >
                  <img src="/assets/images/soccer1.png" height="19px" width="19px" alt="Soccer Ball" />
                  Soccer
                </div>
              </div>
              
              <div className="d-flex gap-2 pb-1">
                {activeTab !== "myMatches" && (
                  <button
                    type="button"
                    className="btn btn-sm btn-primary px-3 py-1"
                    onClick={handleAll}
                    disabled={addAllLoading}
                  >
                    {addAllLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Adding...Please Wait
                      </>
                    ) : (
                      "Add All"
                    )}
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-sm btn-primary refreshButton px-3 py-1"
                  onClick={handleRefresh}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Refreshing...
                    </>
                  ) : (
                    "Refresh"
                  )}
                </button>
              </div>
            </div>

            {/* Search Box */}
            <div className="mt-3">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={`Search in ${activeTab1} matches...`}
                      value={searchTerm}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="text-muted">
                    {loading ? (
                      <span>Loading...</span>
                    ) : (
                      <span>
                        Showing {filteredMatches.length} of {matches.length} matches
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Loading Indicator */}
            {loading && (
              <div className="text-center py-4">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}

            {/* Matches Table */}
            <div className="table-responsive">
              <table
                role="grid"
                className="table table-hover datatable table-striped mt-4"
              >
                <thead className="bg-dark text-light">
                  <tr>
                    <th>Sport Name</th>
                    <th>Competition Name</th>
                    <th>Market Name</th>
                    <th>Open Date</th>
                    {activeTab !== "myMatches" && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {!loading && filteredMatches.length > 0 ? (
                    filteredMatches.map((match, index) => {
                      const currentLockStatus = lockStates[match.eventid] ?? match.lockstatus;
                      const isAddingMatch = addMatchLoading[match.eventid];
                      
                      return (
                        <tr className="border" key={`${match.eventid}-${index}`}>
                          <td className="border">
                            <div>{match.sportname}</div>
                            <div className="text-bold">{match.eventname}</div>
                          </td>
                          <td className="border">{match.competitionname}</td>
                          <td className="border">{match.marketname}</td>
                          <td className="border">{new Date(match.opendate).toISOString().replace("T", " ").replace("Z", "")}</td>

                          {activeTab !== "myMatches" && (
                            <td className="d-flex gap-3">
                              <button 
                                className="btn btn-primary btn-sm ms-2" 
                                onClick={() => AddMatch(match.eventid)}
                                disabled={isAddingMatch}
                                style={{ cursor: "pointer", minWidth: "80px" }}
                              >
                                {isAddingMatch ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                    Adding...
                                  </>
                                ) : (
                                  "Add"
                                )}
                              </button>
                              <div className="form-row customtoggle">
                                <div className="form-group">
                                  <label htmlFor={`lockuser-${match.eventid}`} title="Self Lock" />
                                  <div className="toggle_bx">
                                    <label className="switch">
                                      <input
                                        id={`lockuser-${match.eventid}`}
                                        type="checkbox"
                                        checked={currentLockStatus === 2}
                                        onChange={(e) => {
                                          const newStatus = e.target.checked ? 2 : 1;
                                          toggleLockMatch(newStatus, match.eventid);
                                        }}
                                      />
                                      <div className="slider round extratoggle" />
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })
                  ) : !loading ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        {searchTerm ? `No matches found for "${searchTerm}"` : "No matches available"}
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          </section>
        </div>
        
        <a
          id="back-to-tops"
          href="##"
          className="btn btn-primary back-to-top"
          role="button"
          aria-label="Scroll to top"
        >
          <i className="fas fa-chevron-up" />
        </a>
      </div>
    </>
  );
};

export default AdminMatches;